import { type JWTPayload } from 'jose';

import decodeJWT from './decodeJWT';

function getToken(): string | null;
function getToken({ decoded }: { decoded: false }): string | null;
function getToken({ decoded }: { decoded: true }): JWTPayload | null;

function getToken({ decoded = false } = {}): any {
  let token: string | null = window.location.hash.slice(1); // url#token
  let decodedToken = decodeJWT(token);

  if (decodedToken !== null) {
    localStorage.setItem('editor-token', token);
  } else {
    token = localStorage.getItem('editor-token');

    if (token) {
      decodedToken = decodeJWT(token);
    }
  }

  return decoded ? decodedToken : token;
}

export default getToken;
